export default __webpack_public_path__ + "static/media/ITOAM.2e334b55.svg";